<img [src]="path()"
     *ngIf="path()"
     appImageFallback="assets/img/generic-avatar.svg"
     class="player-avatar"
     alt="profile image">

<img src="assets/img/generic-avatar.svg"
     *ngIf="!path() && !fallback()"
     class="player-avatar"
     alt="profile image">

<div *ngIf="!path() && fallback()" [style.background-color]="'#'+fallback()!.color" class="profile-image-fallback">
    {{fallback()!.initials}}
</div>

